import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatPaginator, MatSort } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';
import { fuseAnimations } from '../../../../../core/animations';
import { TranslationService } from '../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../services/sweet-alert/sweet-alert.service';
import { ExamCallService } from '../../../../services/exam-call/exam-call.service';
import { ExamCall } from '../../../../models/exam-calls/exam-call';
import { SchoolYearService } from '../../../../services/schoool-year/school-year.service';
import { SchoolYear } from '../../../../models/school-years/school-year';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';
import { AddEditExamCallComponent } from './components/add-edit-exam-call/add-edit-exam-call.component';
import { DownloadExamCallsComponent } from './components/download-exam-calls/download-exam-calls.component';
import { BulkEditExamBoardsComponent } from './components/bulk-edit-exam-boards/bulk-edit-exam-boards.component';
import { Router } from '@angular/router';

@Component({
    selector: 'fuse-exam-calls',
    templateUrl: './exam-calls.component.html',
    styleUrls: ['./exam-calls.component.scss'],
    animations: fuseAnimations
})
export class ExamCallsComponent implements OnInit, OnDestroy {
    @BlockUI('tracker') blockUI: NgBlockUI;
    displayedColumns = ['Description', 'Month', 'CallNumber', 'Type', 'Actions'];
    examCallDatabase: ExamCallDatabase;
    dataSource: ExamCallDataSource | null;

    months: any[] = [
        { id: 1, name: 'MONTHS.JANUARY' },
        { id: 2, name: 'MONTHS.FEBRUARY' },
        { id: 3, name: 'MONTHS.MARCH' },
        { id: 4, name: 'MONTHS.APRIL' },
        { id: 5, name: 'MONTHS.MAY' },
        { id: 6, name: 'MONTHS.JUNE' },
        { id: 7, name: 'MONTHS.JULY' },
        { id: 8, name: 'MONTHS.AUGUST' },
        { id: 9, name: 'MONTHS.SEPTEMBER' },
        { id: 10, name: 'MONTHS.OCTOBER' },
        { id: 11, name: 'MONTHS.NOVEMBER' },
        { id: 12, name: 'MONTHS.DECEMBER' }
    ];
    callNumbers: any[] = [
        { id: 1, name: 'CALL_NUMBERS.FIRST' },
        { id: 2, name: 'CALL_NUMBERS.SECOND' },
        { id: 3, name: 'CALL_NUMBERS.THIRD' },
        { id: 4, name: 'CALL_NUMBERS.FOURTH' },
        { id: 5, name: 'CALL_NUMBERS.FIFTH' },
        { id: 6, name: 'CALL_NUMBERS.SIXTH' },
        { id: 7, name: 'CALL_NUMBERS.SEVENTH' },
        { id: 8, name: 'CALL_NUMBERS.EIGHTH' },
        { id: 9, name: 'CALL_NUMBERS.NINTH' },
        { id: 10, name: 'CALL_NUMBERS.TENTH' }
    ];

    getMonthName(id: number) {
        const month = this.months.find(m => m.id === id);
        return month ? month.name : '';
    }

    getCallNumberName(id: number) {
        const cn = this.callNumbers.find(c => c.id === id);
        return cn ? cn.name : '';
    }

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('filter') filter: ElementRef;

    schoolYears: SchoolYear[] = [];
    schoolYearSelected: number;

    constructor(
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private examCallService: ExamCallService,
        private schoolYearService: SchoolYearService,
        private authService: AuthenticationService,
        private router: Router,
        public dialog: MatDialog
    ) { }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);

        const authData = this.authService.getAuthData();
        if (authData && authData.SchoolYear) {
            this.schoolYearSelected = authData.SchoolYear.Id;
        }

        this.schoolYearService.getAll().subscribe(res => {
            this.schoolYears = res;
            if (!this.schoolYearSelected && this.schoolYears.length > 0) {
                this.schoolYearSelected = this.schoolYears[0].Id;
            }
            this.loadData();
        });
    }

    loadData() {
        this.examCallDatabase = new ExamCallDatabase(this.examCallService, this.schoolYearSelected);
        this.dataSource = new ExamCallDataSource(this.examCallDatabase, this.paginator, this.sort);

        Observable.fromEvent(this.filter.nativeElement, 'keyup')
            .debounceTime(150)
            .distinctUntilChanged()
            .subscribe(() => {
                if (!this.dataSource) return;
                this.dataSource.filter = this.filter.nativeElement.value;
            });

        this.blockUI.stop();
    }

    refreshData() {
        this.loadData();
    }

    download() {
        this.dialog.open(DownloadExamCallsComponent, {
            panelClass: 'download-exam-calls-dialog',
            width: '600px',
            data: {
                examCalls: this.examCallDatabase.data
            }
        });
    }

    bulkEdit() {
        if (!this.schoolYearSelected) {
            this.sweetAlertService.info('Info', 'Por favor, seleccione un ciclo lectivo.');
            return;
        }
        this.router.navigate(['pages/management/exam-calls/bulk-edit', this.schoolYearSelected]);
    }

    onSchoolYearChange(id: number) {
        this.schoolYearSelected = id;
        this.loadData();
    }

    add() {
        const dialogRef = this.dialog.open(AddEditExamCallComponent, {
            panelClass: 'add-edit-exam-call-dialog',
            width: '600px',
            data: {
                mode: 'add',
                examCall: new ExamCall(),
                schoolYearId: this.schoolYearSelected
            }
        });

        dialogRef.afterClosed().subscribe(res => {
            if (res) this.loadData();
        });
    }

    edit(examCall: ExamCall) {
        const dialogRef = this.dialog.open(AddEditExamCallComponent, {
            panelClass: 'add-edit-exam-call-dialog',
            width: '600px',
            data: {
                mode: 'edit',
                examCall: Object.assign({}, examCall),
                schoolYearId: this.schoolYearSelected
            }
        });

        dialogRef.afterClosed().subscribe(res => {
            if (res) this.loadData();
        });
    }

    delete(examCall: ExamCall) {
        this.sweetAlertService.question(
            this.translationService.confirmation,
            this.translationService.deletionConfirmationQuestion,
            this.translationService.yes,
            this.translationService.no,
            () => {
                this.blockUI.start(this.translationService.loading);
                this.examCallService.delete(examCall.Id).subscribe(res => {
                    this.blockUI.stop();
                    if (res.ResultCode === 1) {
                        this.sweetAlertService.success(this.translationService.success, this.translationService.deletedCorrectly, null);
                        this.loadData();
                    }
                });
            }
        );
    }

    goToExamBoards(examCall: ExamCall) {
        this.router.navigate(['/pages/management/exam-boards', examCall.Id, this.schoolYearSelected]);
    }

    ngOnDestroy() { }
}

export class ExamCallDatabase {
    dataChange: BehaviorSubject<ExamCall[]> = new BehaviorSubject<ExamCall[]>([]);
    get data(): ExamCall[] { return this.dataChange.value; }

    constructor(private examCallService: ExamCallService, schoolYearId: number) {
        if (schoolYearId) {
            this.examCallService.getBySchoolYear(schoolYearId).subscribe(res => {
                this.dataChange.next(res);
            });
        }
    }
}

export class ExamCallDataSource extends DataSource<any> {
    _filterChange = new BehaviorSubject('');
    get filter(): string { return this._filterChange.value; }
    set filter(filter: string) { this._filterChange.next(filter); }

    filteredData: ExamCall[] = [];
    renderedData: ExamCall[] = [];

    constructor(
        private _database: ExamCallDatabase,
        private _paginator: MatPaginator,
        private _sort: MatSort
    ) {
        super();
        this._filterChange.subscribe(() => this._paginator.pageIndex = 0);
    }

    connect(): Observable<ExamCall[]> {
        const displayDataChanges = [
            this._database.dataChange,
            this._sort.sortChange,
            this._filterChange,
            this._paginator.page
        ];

        return Observable.merge(...displayDataChanges).map(() => {
            this.filteredData = this._database.data.slice().filter((item: ExamCall) => {
                const searchStr = (item.Description).toLowerCase();
                return searchStr.indexOf(this.filter.toLowerCase()) !== -1;
            });

            const sortedData = this.sortData(this.filteredData.slice());
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            this.renderedData = sortedData.splice(startIndex, this._paginator.pageSize);
            return this.renderedData;
        });
    }

    disconnect() { }

    sortData(data: ExamCall[]): ExamCall[] {
        if (!this._sort.active || this._sort.direction === '') return data;

        return data.sort((a, b) => {
            let propertyA: number | string = '';
            let propertyB: number | string = '';

            switch (this._sort.active) {
                case 'Description': [propertyA, propertyB] = [a.Description, b.Description]; break;
                case 'Type': [propertyA, propertyB] = [a.Type, b.Type]; break;
                case 'Month': [propertyA, propertyB] = [a.Month, b.Month]; break;
                case 'CallNumber': [propertyA, propertyB] = [a.CallNumber || 0, b.CallNumber || 0]; break;
            }

            const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/exam-calls/exam-calls.component.ts